/* assets/neb-offers.js
   Nebulyn – Offers Drawer controller + Coupon copy

   Expects:
   - Header trigger: [data-neb-open-offers]
   - Drawer: #NebOffersDrawer (class .neb-offers-drawer)
   - Overlay: .neb-offers-overlay
   - Close button: .neb-offers-close (inside drawer)

   Copy behavior:
   - Any element with [data-neb-copy-text] will copy its value on click
   - Also supports legacy [data-neb-copy-offer] + [data-neb-offer-code]
*/
(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function getParts() {
    var root =
      qs('[data-neb-offers-root]') ||
      qs('#shopify-section-neb-offers-drawer') ||
      document;

    var drawer = qs('#NebOffersDrawer', root) || qs('#NebOffersDrawer');
    var overlay = qs('.neb-offers-overlay', root) || qs('.neb-offers-overlay');

    return { root: root, drawer: drawer, overlay: overlay };
  }

  function isOpen(drawer) {
    return !!drawer && !drawer.hasAttribute('hidden') && drawer.getAttribute('aria-hidden') === 'false';
  }

  // --- Scroll lock without page jump ---
var __nebOffersScrollY = 0;

function lockScroll(yes) {
  var html = document.documentElement;
  var body = document.body;

  if (yes) {
    __nebOffersScrollY = window.scrollY || window.pageYOffset || 0;

    html.classList.add('neb-no-scroll');
    body.style.position = 'fixed';
    body.style.top = (-__nebOffersScrollY) + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
  } else {
    html.classList.remove('neb-no-scroll');

    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';

    window.scrollTo(0, __nebOffersScrollY || 0);
  }
}

  function openDrawer() {
    var parts = getParts();
    var drawer = parts.drawer;
    var overlay = parts.overlay;
    if (!drawer || !overlay) return;

    overlay.removeAttribute('hidden');
    drawer.removeAttribute('hidden');

    overlay.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('aria-modal', 'true');
    drawer.classList.add('is-open');

    lockScroll(true);

    var closeBtn = qs('.neb-offers-close', drawer);
    if (closeBtn) {
      try { closeBtn.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function closeDrawer() {
    var parts = getParts();
    var drawer = parts.drawer;
    var overlay = parts.overlay;
    if (!drawer || !overlay) return;

    overlay.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');

    overlay.setAttribute('hidden', '');
    drawer.setAttribute('hidden', '');

    lockScroll(false);
  }

  function toggleDrawer() {
    var parts = getParts();
    if (!parts.drawer) return;
    if (isOpen(parts.drawer)) closeDrawer();
    else openDrawer();
  }

  // ---------------------------
  // Copy helpers (SAFE add-on)
  // ---------------------------
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  function copyText(text) {
    text = (text || '').trim();
    if (!text) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch(function () {
        fallbackCopy(text);
      });
    } else {
      fallbackCopy(text);
    }
  }

  function flashCopied(btn) {
    if (!btn) return;
    var prev = btn.textContent;
    btn.textContent = 'Copied';
    clearTimeout(btn._nebCopyT);
    btn._nebCopyT = setTimeout(function () {
      btn.textContent = prev || 'Copy';
    }, 1200);
  }

  function bindOnce() {
    if (document.documentElement.dataset.nebOffersBound === 'true') return;
    document.documentElement.dataset.nebOffersBound = 'true';

    // Click handling (delegated)
    document.addEventListener(
      'click',
      function (e) {
        // OPEN trigger (header icon)
        var openBtn = e.target.closest('[data-neb-open-offers]');
        if (openBtn) {
          e.preventDefault();
          e.stopPropagation();
          toggleDrawer();
          return;
        }

        // CLOSE button
        var closeBtn = e.target.closest('.neb-offers-close');
        if (closeBtn) {
          e.preventDefault();
          e.stopPropagation();
          closeDrawer();
          return;
        }

        // OVERLAY click closes
        var overlayClick = e.target.closest('.neb-offers-overlay');
        if (overlayClick) {
          e.preventDefault();
          e.stopPropagation();
          closeDrawer();
          return;
        }

        // ✅ COPY (new): anything with data-neb-copy-text
        var copyEl = e.target.closest('[data-neb-copy-text]');
        if (copyEl) {
          e.preventDefault();
          e.stopPropagation();
          copyText(copyEl.getAttribute('data-neb-copy-text'));
          if (copyEl.matches('button')) flashCopied(copyEl);
          return;
        }

        // ✅ COPY (legacy): button [data-neb-copy-offer] + code [data-neb-offer-code]
        var legacyBtn = e.target.closest('[data-neb-copy-offer]');
        if (legacyBtn) {
          e.preventDefault();
          e.stopPropagation();

          var wrap = legacyBtn.closest('.neb-offer');
          var codeEl = wrap ? qs('[data-neb-offer-code]', wrap) : null;
          var txt = codeEl ? (codeEl.textContent || '').trim() : '';

          copyText(txt);
          flashCopied(legacyBtn);
          return;
        }
      },
      { capture: true }
    );

    // Keyboard support: Enter/Space on coupon <code> or anything with role=button
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var parts = getParts();
        if (parts.drawer && isOpen(parts.drawer)) closeDrawer();
        return;
      }

      if (e.key !== 'Enter' && e.key !== ' ') return;

      var el = e.target && e.target.closest ? e.target.closest('[data-neb-copy-text]') : null;
      if (!el) return;

      // Only if it's meant to be clickable (code/role/button)
      if (!(el.matches('code') || el.getAttribute('role') === 'button')) return;

      e.preventDefault();
      copyText(el.getAttribute('data-neb-copy-text'));
    });

    // Safety normalization on load
    window.addEventListener('load', function () {
      var parts = getParts();
      if (!parts.drawer || !parts.overlay) return;

      if (parts.drawer.classList.contains('is-open') && parts.drawer.hasAttribute('hidden')) {
        parts.drawer.classList.remove('is-open');
      }

      if (!parts.overlay.hasAttribute('hidden') && parts.drawer.hasAttribute('hidden')) {
        parts.overlay.setAttribute('hidden', '');
        parts.overlay.setAttribute('aria-hidden', 'true');
      }

      if (document.documentElement.classList.contains('neb-no-scroll')) {
        if (!(parts.drawer && isOpen(parts.drawer))) lockScroll(false);
      }
    });
  }

  // Bind immediately + after Shopify section reloads (Theme Editor)
  bindOnce();

  document.addEventListener('shopify:section:load', function () {
    bindOnce();
  });

  // Debug helpers
  window.NebOffers = window.NebOffers || {};
  window.NebOffers.open = openDrawer;
  window.NebOffers.close = closeDrawer;
  window.NebOffers.toggle = toggleDrawer;
})();